import React from 'react';
import * as Sentry from '@sentry/react';
import pkg from '../../../package.json';

import {
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
} from 'react-router-dom';

type QualityAppScope = {
    user?: Sentry.User;
};

export function setSentryScope({ user }: QualityAppScope): void {
    Sentry.getGlobalScope().setUser(user);
}

function getEnvironment() {
    if (window.location.origin.includes('localhost')) {
        return 'development';
    }

    if (window.location.origin.includes('.dev')) {
        return 'staging';
    }

    return 'production';
}

const environment = getEnvironment();

export function initSentry(): void {
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        release: `qa-tool-webapp-frontend@${pkg.version}`,
        environment,
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
        ],
        tracesSampleRate: 1,
        tracePropagationTargets: [/^\//, /https?:\/\/.*\/graphql/],
        replaysOnErrorSampleRate: 1,
        enabled: environment !== 'development',
    });
}
